const formatPhoneNumber = (phoneNumber = "") => {
  // Remove whitespaces and only accept number, *, and #
  const number = phoneNumber.trim().replace(/[^0-9*#]/g, "");

  // Add hyphen separators
  if (number.length < 4) return number;
  if (number.length < 9) return number.replace(/(\d{4})(\d{1})/, "$1-$2");
  if (number.length < 13) return number.replace(/(\d{4})(\d{4})(\d{1})/, "$1-$2-$3");
  if (number.length < 17) return number.replace(/(\d{4})(\d{4})(\d{4})(\d{1})/, "$1-$2-$3-$4");
  return number.replace(/(\d{4})(\d{4})(\d{4})(\d{3})/, "$1-$2-$3-$4");
}

export default formatPhoneNumber;